import { partitionAttention, isStaleOrder, attentionScopeLine } from './orderFreshness.js'
export function orderRollup(data=[],now=new Date()) {
  const active=data.filter(a=>!a.complete&&a.phase!=='complete')
  const current=active.filter(a=>!isStaleOrder(a,now))
  const flagged=active.filter(a=>a.atRisk||a.phase==='hold'||a.phase==='approvals').sort((a,b)=>(a.dueDate?new Date(a.dueDate).getTime():Infinity)-(b.dueDate?new Date(b.dueDate).getTime():Infinity))
  const part=partitionAttention(flagged,now)
  return {total:current.length,totalAllTime:data.length,approval:current.filter(a=>a.phase==='approvals').length,attention:part.current.length,staleCount:part.stale.length,staleLine:attentionScopeLine(part),list:part.current.slice(0,5)}
}
